import { SpecialInfoTypes } from '@booking/constants/special-info-types';

import { AssetTermBase } from './asset-terms.base';
import { CASHBACK_TRAVEL } from '../country-assets/BR/cashback';
import { ELO_TRAVEL } from '../country-assets/BR/elo';
import { LIVELO_TRAVEL } from '../country-assets/BR/livelo';
import { PONTOS_DOTZ_TRAVEL } from '../country-assets/BR/pontos-dotz';
import { TUDO_AZUL_TRAVEL } from '../country-assets/BR/tudo-azul';
import { HOW_RENT } from '../country-assets/BR/rent';
import { RAPPICARD_BR_TERMS } from '../country-assets/BR/rappi-card';
import { CASHBACK_HOTEL_CARS } from '../country-assets/BR/cashback-hotel-cars';
import { BLACK_FRIDAY } from '../country-assets/BR/black-friday-travel';
import { CHUBB_TERMS } from '../country-assets/BR/chubb-br';
import { CIVITATIS_TERMS } from '../pt-assets/civitatis-pt';

export const AssetTerm = {
  ...AssetTermBase,
  CASHBACK_TRAVEL: CASHBACK_TRAVEL,
  ELO_TRAVEL: ELO_TRAVEL,
  LIVELO_TRAVEL: LIVELO_TRAVEL,
  TUDO_AZUL_TRAVEL: TUDO_AZUL_TRAVEL,
  PONTOS_DOTZ_TRAVEL: PONTOS_DOTZ_TRAVEL,
  HOW_RENT: HOW_RENT,
  RAPPICARD_TERMS: RAPPICARD_BR_TERMS,
  CASHBACK_HOTEL_CARS: CASHBACK_HOTEL_CARS,
  BLACK_FRIDAY: BLACK_FRIDAY,
  CHUBB_TERMS: CHUBB_TERMS,
  CIVITATIS_TERMS: CIVITATIS_TERMS,
  DAVIVIENDA: null,
  SUMMARY_TERMS_AND_POLICIES: {
    INDIVIDUAL_TERMS: false,
    CAMPAIGNS_TERMS_IN_FOOTER: false,
    INITIAL_TEXT: 'Li e aceito',
    FINAL_TEXT: 'da Agência de Viagens e Turismo Rappi.',
    TERMS_AND_CONDITIONS: {
      INITIAL_TEXT: 'os',
      ALTERNATIVE_TEXT: 'e os',
      HREF: {
        COMMANDS: [{ outlets: { 'terms': ['terms'] } }],
        TEXT: 'Termos e Condições',
        STATE: {}
      },
    },
    TREATMENT_PERSONAL_POLICIES: {
      DISABLED: true,
      INITIAL_TEXT: 'o',
      ALTERNATIVE_TEXT: '',
      HREF: {
        COMMANDS: [{ outlets: { 'terms': ['treatment-personal-data'] } }],
        TEXT: 'Tratamento de dados pessoais do site',
        STATE: {}
      }
    },
    PRIVACY_POLICIES: {
      INITIAL_TEXT: 'e a',
      ALTERNATIVE_TEXT: 'a',
      HREF: {
        COMMANDS: [{ outlets: { 'terms': ['private-policy'] } }],
        TEXT: 'Política de Privacidade',
        STATE: {}
      }
    },
    CIVITATIS_POLICIES: {
      INITIAL_TEXT: 'os',
      ALTERNATIVE_TEXT: 'do Civitatis.',
      HREF: {
        COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
        TEXT: 'Termos e Condições',
        STATE: {
          infoType: SpecialInfoTypes.CIVITATIS
        }
      }
    },
    CAMPAIGNS_TERMS: [
      {
        INITIAL_TEXT: 'os',
        ALTERNATIVE_TEXT: '',
        HREF: {
          COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
          TEXT: 'Termos e Condições da Campanha Cashback Rappicard',
          STATE: { infoType: SpecialInfoTypes.RAPPICARD_TERMS }
        }
      },
      {
        DISABLED: true,
        INITIAL_TEXT: 'os',
        ALTERNATIVE_TEXT: 'a',
        HREF: {
          COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
          TEXT: 'Termos e Condições Promoção ELO',
          STATE: { infoType: SpecialInfoTypes.ELO }
        }
      },
      {
        DISABLED: true,
        INITIAL_TEXT: 'os',
        ALTERNATIVE_TEXT: '',
        HREF: {
          COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
          TEXT: 'Termos e Condições da Campanha Dotz',
          STATE: { infoType: SpecialInfoTypes.PONTOS_DOTZ }
        }
      },
      {
        DISABLED: true,
        INITIAL_TEXT: '',
        ALTERNATIVE_TEXT: '',
        HREF: {
          COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
          TEXT: 'Termos e Condições da Campanha acúmulo de pontos LIVELO',
          STATE: { infoType: SpecialInfoTypes.LIVELO }
        }
      },
      {
        DISABLED: true,
        INITIAL_TEXT: '',
        ALTERNATIVE_TEXT: '',
        HREF: {
          COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
          TEXT: 'Termos e Condições Promoção TudoAzul',
          STATE: { infoType: SpecialInfoTypes.TUDO_AZUL }
        }
      },
      {
        DISABLED: true,
        INITIAL_TEXT: '',
        ALTERNATIVE_TEXT: 'a',
        HREF: {
          COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
          TEXT: 'Termos e Condições da Campanha 5% OFF Hotéis e Carros',
          STATE: { infoType: SpecialInfoTypes.CASHBACK_HOTELS_AND_CARS }
        }
      },
      {
        DISABLED: true,
        INITIAL_TEXT: 'os',
        ALTERNATIVE_TEXT: 'a',
        HREF: {
          COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
          TEXT: 'Termos e Condições da Campanha de Black Friday Rappi Travel',
          STATE: { infoType: SpecialInfoTypes.BLACK_FRIDAY }
        }
      },
      {
        DISABLED: true,
        INITIAL_TEXT: 'os',
        ALTERNATIVE_TEXT: '',
        HREF: {
          COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
          TEXT: 'Termos e Condições da CHUBB Seguro',
          STATE: { infoType: SpecialInfoTypes.CHUBB }
        }
      },
    ],
  }
};
